export enum InvitationResponse {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  INVITED = 'INVITED',
}
